import { Component } from "@angular/core";

import { PageInfoTemplateComponent } from "../page-info-template.component";

@Component({
    templateUrl: "../page-info-template.component.html",
    styleUrls: ["../page-info-template.component.scss"]
})
export class PageNotFoundComponent extends PageInfoTemplateComponent {
    constructor() {
        super();
        this.errorCode = "404 ERROR";
        this.message = "For some reason the page you requested could not be found on server.";
    }
}
